import {
  GET_DASH_INFO,
  GET_DASH_INFO_SUCCESS,
  GET_DASH_INFO_FAILURE,
  GET_REG_PER_MONTH,
  GET_REG_PER_MONTH_SUCCESS,
  GET_REG_PER_MONTH_FAILURE,
} from "../constants";

export default class AdminAction {
  static getDashInfo(cb) {
    return {
      type: GET_DASH_INFO,
      cb,
    };
  }
  static getDashInfoSuccess(payload) {
    return {
      type: GET_DASH_INFO_SUCCESS,
      payload,
    };
  }
  static getDashInfoFailure(payload) {
    return {
      type: GET_DASH_INFO_FAILURE,
      payload,
    };
  }
  static getRegPerMonth(cb) {
    return {
      type: GET_REG_PER_MONTH,
      cb,
    };
  }
  static getRegPerMonthSuccess(payload) {
    return {
      type: GET_REG_PER_MONTH_SUCCESS,
      payload,
    };
  }
  static getRegPerMonthFailure(payload) {
    return {
      type: GET_REG_PER_MONTH_FAILURE,
      payload,
    };
  }
}
